import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetothanecab() {



  const cardData = {
"keyword": "Pune to Thane Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Thane Cab service for travelers seeking safe, affordable, and convenient intercity transportation. Whether you are traveling for business meetings, family visits, airport transfers, corporate travel, or weekend trips, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Thane. Our fleet includes sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, and 24/7 customer support, Shivai Travels ensures comfortable and timely travel between Pune and Thane.",

"topPlaces": [
  {
    "title": "Upvan Lake",
    "description":
      "Upvan Lake is a beautiful and peaceful lake in Thane known for evening walks, boating, and scenic surroundings. Travelers using Pune to Thane cab service often visit this relaxing destination."
  },
  {
    "title": "Yeoor Hills",
    "description":
      "Yeoor Hills is a green and scenic area near Sanjay Gandhi National Park offering nature trails and peaceful views. Cab travelers from Pune enjoy visiting this refreshing getaway in Thane."
  },
  {
    "title": "Viviana Mall",
    "description":
      "Viviana Mall is one of the largest shopping and entertainment destinations in Thane featuring retail stores, restaurants, and cinemas. Pune to Thane cab service provides convenient access for shopping and leisure trips."
  },
  {
    "title": "Masunda Lake (Talao Pali)",
    "description":
      "Masunda Lake is a famous landmark in Thane known for boating and lively surroundings. Travelers from Pune often include this scenic attraction in their city visit."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description":
      "Sanjay Gandhi National Park near Thane is a popular destination for wildlife, trekking, and nature experiences. Cab service from Pune offers comfortable travel for nature lovers."
  },
  {
    "title": "Korum Mall",
    "description":
      "Korum Mall is a well-known shopping and lifestyle destination in Thane. Pune to Thane cab travelers often visit this modern mall for entertainment and dining."
  },
  {
    "title": "Suraj Water Park",
    "description":
      "Suraj Water Park is a popular amusement and water park in Thane ideal for family outings and fun activities. Cab service from Pune makes it easy to enjoy a refreshing day trip."
  },
  {
    "title": "Tikuji-ni-Wadi",
    "description":
      "Tikuji-ni-Wadi is a family entertainment and resort destination in Thane offering water rides and recreational activities. Travelers from Pune often visit this attraction for weekend enjoyment."
  },
  {
    "title": "Kelva Beach (Nearby Route)",
    "description":
      "Kelva Beach near Thane is known for peaceful coastal views and relaxing atmosphere. Pune to Thane cab service offers a comfortable travel option for beach lovers."
  },
  {
    "title": "Ovalekar Wadi Butterfly Garden",
    "description":
      "Ovalekar Wadi Butterfly Garden is a unique nature attraction in Thane featuring butterfly conservation and greenery. Cab travelers from Pune often visit this eco-friendly destination."
  }
],



services: [
  {
    name: "Pune to Thane Cab",
    description: "Pune to Thane cab service provides reliable transportation between Pune and Thane with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Thane Taxi",
    description: "Pune to Thane taxi service offers dependable transportation for passengers traveling between Pune and Thane with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Thane",
    description: "Cab from Pune to Thane service provides comfortable intercity transportation for passengers traveling for business, tourism, airport transfers, and family visits. Vehicles ensure reliable expressway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Thane. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Thane",
    description: "Taxi from Pune to Thane service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Thane. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Thane Cab Service",
    description: "Pune to Thane cab service provides dependable transportation solutions for passengers traveling between Pune and Thane with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for expressway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Ideal for business travel, airport transfers, and tourism trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Thane Taxi Fare",
    description: "Pune to Thane taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Thane. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Thane One Way Cab",
    description: "Pune to Thane one way cab service provides economical transportation for passengers traveling from Pune to Thane without return travel requirements. Comfortable vehicles ensure smooth expressway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Thane including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Thane Round Trip Taxi",
    description: "Pune to Thane round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Thane. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Thane Cab Booking",
    description: "Pune to Thane cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Thane. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Thane Cab",
    description: "Cheap Pune to Thane cab service provides affordable transportation between Pune and Thane with comfortable vehicles and economical pricing. Vehicles ensure reliable expressway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Thane. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Thane Taxi",
    description: "Best Pune to Thane taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Thane Cab",
    description: "Sedan Pune to Thane cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Thane. Sedan vehicles provide smooth expressway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Thane. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Thane Taxi",
    description: "SUV Pune to Thane taxi service provides spacious transportation for families and groups traveling between Pune and Thane. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Thane Cab",
    description: "Innova Pune to Thane cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Thane. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Expressway Cab Pune Thane",
    description: "Expressway cab Pune Thane service offers dependable transportation via the Mumbai–Pune Expressway with comfortable vehicles and experienced chauffeurs. Vehicles ensure smooth highway travel suitable for business trips, airport transfers, tourism, and family travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Thane. Flexible booking options allow convenient expressway cab reservations."
  },
  {
    name: "Thane to Pune Cab Service",
    description: "Thane to Pune cab service provides reliable return transportation between Thane and Pune with comfortable vehicles and professional drivers. Vehicles ensure smooth expressway travel suitable for business travel, airport transfers, tourism, and family journeys. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Thane and Pune. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Thane Cab", "Pune to Thane Taxi"],
  ["Cab from Pune to Thane", "Taxi from Pune to Thane"],
  ["Pune to Thane Cab Service", "Pune to Thane Taxi Fare"],
  ["Pune to Thane One Way Cab", "Pune to Thane Round Trip Taxi"],
  ["Pune to Thane Cab Booking", "Cheap Pune to Thane Cab"],
  ["Best Pune to Thane Taxi", "Sedan Pune to Thane Cab"],
  ["SUV Pune to Thane Taxi", "Innova Pune to Thane Cab"],
  ["Expressway Cab Pune Thane", "Thane to Pune Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Thane Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Thane cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe intercity travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Thane Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Thane cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Thane Cab Service Availability",
        WhyChoosedescription: "Our Pune to Thane cab service operates 24 hours a day for business travel, family trips, airport transfers, emergency transportation, and outstation journeys."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Thane taxi service, round-trip bookings, Mumbai region travel, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Expressway Drivers",
        WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai Pune Expressway and Thane routes, ensuring safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Thane cab service?", answer: "Pune to Thane cab service provides comfortable taxi transportation between Pune and Thane for business travel, family trips, and airport transfers." },
    { question: "Is Pune to Thane cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Thane cab service." },
    { question: "Which vehicles are available for Pune to Thane travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Thane?", answer: "Yes, customers can book one-way as well as round-trip Pune to Thane taxi services." },
    { question: "Do you provide airport transfer services from Thane?", answer: "Yes, Shivai Travels provides airport transfer services for Mumbai Airport and nearby locations." },
    { question: "Are all Pune to Thane taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Thane cab service online?", answer: "Yes, customers can easily book Pune to Thane cab service online or through phone booking." },
    { question: "Do you provide cabs for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family trips and corporate travel." },
    { question: "Are Pune to Thane cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Thane cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Kiran Deshmukh",
      feedback:
        "Booked Pune to Thane cab service with Shivai Travels. Comfortable vehicle, professional driver, and smooth expressway travel.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Sneha Shah",
      feedback:
        "Excellent Pune to Thane taxi service. Affordable pricing, punctual pickup, and very reliable travel experience.",
      rating: 5
    }
  ];




































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Thane Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-thane-cab.jpg",
  "description": "Book Pune to Thane cab service for safe and comfortable travel via expressway. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7. Also available Pune to Virar cab service.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-thane-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Thane Cab Service | Affordable Expressway Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Thane cab service for one-way and round trip travel via expressway. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7. Also available Pune to Virar cab service."
  />

  <meta
    name="keywords"
    content="from pune to thane, pune to thane cab service, pune to thane taxi fare, pune to thane one way cab, pune to thane round trip taxi, pune to thane cab booking, cheap pune to thane cab, best pune to thane taxi, sedan pune to thane cab, suv pune to thane taxi, innova pune to thane cab, expressway cab pune thane, cab from thane to pune, Pune to Thane Cab, Pune to Thane Cab Service, Pune to Thane Taxi Service, Pune to Thane Cab Booking, Best Pune to Thane Cab, One Way Pune to Thane Cab, Round Trip Pune to Thane Taxi, Cheap Pune to Thane Cab, 24x7 Pune to Thane Cab Service, Outstation Cab Pune to Thane, Pune to Virar Cab Service, Pune to Virar Taxi Service, Pune to Virar Cab Booking, Best Pune to Virar Cab, One Way Pune to Virar Cab, Round Trip Pune to Virar Taxi, Cheap Pune to Virar Cab, 24x7 Pune to Virar Cab Service, Outstation Cab Pune to Virar, Pune to Virar Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetothanecab;